import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const MessagingCopy = ({
  message
}) => {
  if (!isValidI18nKey(message)) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: message
  });
};
export default MessagingCopy;